
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getPanier, getLocation, getStepLocation, getClient } from "../../../store/selectors.js";
import { stepLocationSlice } from '../../../store/stepLocationSlice.js';

// API fetch
import axios from "axios";
import { appURL, baseURL } from '../../../config/api-config.js';

//Utils 
import { getTotalPanier, getArticlePU, tarifDecimalConverter } from '../../../utils/calcul-tarif'

import { poucesConvertor } from "../../../utils/poucesConvertor.js"

import convertHoraire from '../../../utils/convert_horaire'
import { calculDuree, getDureeInfos } from '../../../utils/calcul-duree'



//MUI :
import Button from '@mui/material/Button';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CheckIcon from '@mui/icons-material/Check';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

//Translate utils :
import { translator } from "../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function LocationValidate({ dbArticles, dbTailles }) { // full page as component imported in router



    let theClient = useSelector(getClient);
    const lang = useSelector(getLang) //global state : language
    const panier = useSelector(getPanier) //global state : shopping step
    const location = useSelector(getLocation) //global state : shopping step

    const locationStep = useSelector(getStepLocation) //global state : shopping step


    let problemes = []; //list to store problems in requests
    let totalResa = 0; //amount of the current resa
    let currentClient = 0; //id of current client
    let currentResa = 0; // id of current resa (got from response)
    let idChanges = []; // list to store the switch of new eleve ids (from -1 to 345 for eg)

    const navigate = useNavigate();
    const dispatch = useDispatch();

    let alertBaseMessage = "Oups, une erreur est parvenue pendant l'enregistrement de votre demande. \n Vous pouvez réessayer à nouveau.\n Code erreur :";
    let [alertMessage, setAlertMessage] = useState("");
    let [showAlert, setShowAlert] = useState(false);
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        if (showAlert === true) {
            setLoading(false);
        }
    }, [showAlert])


    //// -- A faire : si nouveau client -> insérer et récupérer son ID
    // mettre à jour (put) le client courant

    function insertClient() {

        setLoading(true);

        if (theClient.id_client > 0) { //dejà client ->update

            axios.put(`${baseURL}/client/${theClient.id_client}`, { //...we update
                prenom: theClient.prenom,
                nom: theClient.nom,
                email: theClient.email,
                tel: theClient.tel,
                tel2: theClient.tel2,
                adresse_vacances: theClient.adresse_vacances,
                is_eleve: false,
                eleve_id: 0
            })
                .then((response) => {
                    if (response.status === 200) { //modif ok : code 200...
                        // appeler fonction insert Resa
                        insertLocation(theClient.id_client);
                    }
                    else {
                        problemes.push(response.data);
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "Client-put" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    problemes.push(error);
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "Client-put" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        }
        else { //new Client -> insert

            axios.post(`${baseURL}/client`, { //fetch create resa
                prenom: theClient.prenom,
                nom: theClient.nom,
                email: theClient.email,
                tel: theClient.tel,
                tel2: theClient.tel2,
                adresse_vacances: theClient.adresse_vacances,
                is_eleve: false,
                eleve_id: 0
            })
                .then((response) => {
                    if (response.status === 201) { // everything went good..
                        // appeler fonction insert Resa
                        insertLocation(response.data.data.id_client);
                    }
                    else { // if probleme...
                        problemes.push(response.data); //add probleme to list
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "Client-post" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    //console.error(error);
                    problemes.push(error); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "Client-post" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        }
    }



    // créer la nouvelle résa et récupérezr l'id

    function insertLocation(idClient) {

        currentClient = idClient;
        //console.log(formulesEleves)

        let cleanBody = { ...location };
        delete cleanBody.id_location;

        let totalPanier = getTotalPanier(dbArticles, panier, location);
        let refLoc = String(totalPanier.total - totalPanier.difference * totalPanier.combos) + "-" + dayjs().format("DDMM") + "-" + idClient;

        cleanBody = {
            ...cleanBody,
            ref_location: refLoc,
            client_id: idClient,
            total: totalPanier.total - totalPanier.difference * totalPanier.combos,
            solde: totalPanier.total - totalPanier.difference * totalPanier.combos,
            nb_combos: totalPanier.combos,
            discount_combos: totalPanier.combos * totalPanier.difference
        }

        axios.post(`${baseURL}/location`, cleanBody)
            .then((response) => {
                if (response.status === 201) { // everything went good..
                    // appeler fonction insert Resa/creneau
                    insertArticlePanier(response.data.data);

                }
                else { // if probleme...
                    problemes.push(response.data); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "loc-post" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {
                //console.error(error);
                problemes.push(error); //add probleme to list
                // ----- error management
                setAlertMessage(alertBaseMessage + "loc-post" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })

    }





    // bulk create :
    function insertArticlePanier(locInfos) {

        problemes.length = 0; // reset array to empty
        console.log(locInfos.id_location)

        let batch = [];

        panier.forEach(item => {
            batch.push({ ...item, location_id: locInfos.id_location })
        })

        // bulk create
        axios.post(`${baseURL}/article-panier/bulk`, batch)
            .then((response) => {
                if (response.status === 201) { // insertion ok
                    console.log(response.data.data);
                    sendMail(locInfos);
                }
                else { // probleme insertion
                    problemes.push("probleme");
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "ArticlePanier-post" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {
                problemes.push("probleme");
                // ----- error management
                setAlertMessage(alertBaseMessage + "ArticlePanier-post" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })


    } // end of  insertCreneauxEleves()


    function sendMail(locInfos) {

        let htmlBody = mailHtmlCreator(panier, location, theClient, dbArticles, dbTailles, locInfos, "client")
        let htmlBodyWally = mailHtmlCreator(panier, location, theClient, dbArticles, dbTailles, locInfos, "wally")

        let bodyClient = {
            to: theClient.email,
            //to: "manuel.vivion@gmail.com",
            bcc: "reservations@wallyglisse.com",
            subject: "Votre Demande de location de matériel",
            html: htmlBody
        }

        let bodyWally = {
            to: "wallyglisse@gmail.com",
            //to: "manuel.vivion@gmail.com",
            bcc: "reservations@wallyglisse.com",
            subject: `Demande de location de matériel (${theClient.nom})`,
            html: htmlBodyWally
        }


        axios.post(`${baseURL}/mailing/mail-location/client`, bodyClient)
            .then((response) => {
                if (response.status === 200) { //isnertion OK
                    //to not trigger alert message
                    console.log("envoie mail client OK")
                    //-------------------------
                    //envoie mail à wally


                    axios.post(`${baseURL}/mailing/mail-location/wally`, bodyWally)
                        .then((response) => {
                            if (response.status === 200) { //isnertion OK
                                //to not trigger alert message
                                console.log("envoie mail wally OK")
                                confirmSave(true)
                                //envoie mail à wally

                            }
                            else { //mail problème vers client
                                setAlertMessage(alertBaseMessage + "Mail-Demande-2 " + response.status);
                                setShowAlert(true);
                                return response.status

                            }
                        })
                        .catch(error => {
                            setAlertMessage(alertBaseMessage + "Mail-Demande-2B " + error.message);
                            setShowAlert(true);
                            return error
                        })


                    //-------------------------
                }
                else { //mail problème vers client
                    setAlertMessage(alertBaseMessage + "Mail-Demande-1 " + response.status);
                    setShowAlert(true);
                    return response.status

                }
            })
            .catch(error => {
                setAlertMessage(alertBaseMessage + "Mail-Demande-1B " + error.message);
                setShowAlert(true);
                return error
            })

    }



    function confirmSave(success) { // handle insertions completion => show message for exemple
        if (success === true) {
            setLoading(false);
            console.log("c'est bon on t'a dit");
            dispatch(stepLocationSlice.actions.nextStep())

        }
    }


    return (
        <div>

            <Button
                className="bottom-nav-next-confirm"
                onClick={_ => insertClient()}
                variant="contained">
                {translator("Envoyez votre demande de réservation", lang, "confirmResaEnvoyer")} <CheckIcon />
            </Button>
            {loading === true &&
                <CircularProgress />
            }
            {showAlert === true &&
                <Alert className="bottom-nav-next-confirm-alert" severity="error">{alertMessage}</Alert>
            }
        </div>
    );
}

export default LocationValidate;


function mailHtmlCreator(panier, location, client, dbArticles, dbTailles, locInfos, destinataire) {

    function getArticle(item) {
        return dbArticles.find(article => article.id_article === item.article_id)
    }

    function getTailleInfo(taille) {
        let info = dbTailles.find(t => t.id_taille === taille).nom_taille;
        return poucesConvertor(info)
    }

    let totalPanier = getTotalPanier(dbArticles, panier, location);

    let htmlBody = `
    <html lang='fr'>

<head>
    <meta charset='UTF-8'>
    <title>Confirmation de votre réservation</title>
    <style>
    body {
        background-color: white;
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 16px;
    }

    .zebra {
        height: 50px;
        background-image: url("https://www.wallyglisse.com/images/bande_zebra_400par50.jpg");
    }

    .wallybanner {
        position: relative;
        background: linear-gradient(#c53245, #E91E63);
        padding: 8px;
        margin-bottom: 16px;
        border-top: 4px solid white;
        width: auto;
        text-align: center;
    }



    .wallybanner-img {
        width: 80px;
        margin: 0px auto;
    }






        .main-progress-bar,
        .main-container {
            background-color: rgba(255, 255, 255, 0.8);
            border-top: 4px solid #E91E63;
            margin-bottom: 8px;
            position: relative;
            padding: 16px 8px;
        }

        .main-container {
            border: none;
            border-bottom: 2px solid #E0D5B5;
            background-color: rgba(255, 255, 255, 0.8);
            margin-bottom: 4px;
        }

        .location-step3-panier-title,
        .location-step3-infos-periode,
        .location-step3-infos-client {
            position: relative;
        }

        .location-step3-panier-title h3,
        .location-step3-infos-periode h3,
        .location-step3-infos-client h3 {
            width: 100%;
            color: #E91E63;
            text-transform: uppercase;
            text-align: center;
            padding: 8px;
            border-bottom: 1px solid #E0D5B5;
        }



        .location-step3-infos-client-content table,
        .location-step3-infos-periode-content table,
        .location-panier-list table {
            width: 100%;
        }


        .location-step3-infos-periode-content table td {
            width: 30%;
        }

        .location-step3-infos-client-content table td {
            width: 50%;
        }



        .location-step3-infos-periode-content p,
        .location-step3-infos-periode-content h4 {
            margin: 0px;
        }

        .location-panier-list {
            display: flex;
            flex-direction: column;
        }

        .location-panier-list table th,
        .location-panier-list table td,
        .location-panier-list table tr {
            margin: 0px;
        }

        .location-panier-list table {
            border-collapse: collapse
        }

        .location-panier-list table td {
            border-bottom: 3px solid #E0D5B5;
            border-right: 1px solid lightgrey;

        }

        .location-panier-list table p {
            text-align: center;
            font-size: 14px;

        }

        .location-panier-list table h3 {
            font-size: 16px;

        }

        .location-panier-list table .col1 {
            width: 64px;
        }

        .location-panier-list table .col2 p {
            text-align: left;
            margin: 0px;
        }

        .location-panier-list table .col2 h3 {
            text-align: left;
            margin: 0px;
        }

        .location-panier-list table img {
            width:64px;
            height:64px;
        }

        .location-panier-list table .col2 {
            width: 40%;
            padding: 4px;
        }

        .location-panier-list table th {
            border-bottom: 1px solid black;
            padding: 8px 2px;
            font-size: 16px;
        }

        .location-panier-list .ligne-total {
            background-color: #E91E63;
            color: white;
        }

        .location-panier-list .ligne-discount {
            background-color: #E0D5B5;
        }

        .location-panier-list .ligne-discount .col2,
        .location-panier-list .ligne-total .col2 {
            padding: 16px 8px;
        }

        .location-panier-list .ligne-discount td,
        .location-panier-list .ligne-total td {
            border: none;
            border-right: 1px solid white;
        }

        .location-panier-list .ligne-total td p {
            font-size: 16px;
        }
        .bouton-reponse {
            background-color: #362782;
            border-radius: 8px;
            padding: 8px;
        }

        .bouton-reponse p {
            text-align: center;
            text-transform: uppercase;
            color: white;
            text-decoration: none !important;
        }
    </style>
</head>

<body>
    <section>

        <div class="zebra"></div>
        <div class="wallybanner"><img class="wallybanner-img"
                src="https://www.wallyglisse.com/nestor/images/logo_wally.png" alt="logo Wally Glisse">
        </div>
    </section>
    </div>
    
    `
    if (destinataire === "wally") { //mail wally
        htmlBody += `

        <div class="main-container">
        <div class="location-step3-infos-periode">
            <h3>Nouvelle demande de location de matériel</h3>

            <div>
                <div>
                    <p>Yann, tu as reçu une demande de location de matériel, clique sur le lien ci dessous pour y répondre :</p>
                </div>

            </div>
        </div>
    </div>

            <div class="main-container">
             <a href="${appURL + `/location/match/${locInfos.ref_location}/${locInfos.id_location}`}" target="_blank">
             <div class="bouton-reponse">
             <p>Répondre à cette demande</p>
         </div>
             </a>
            </div>
    `
    }

    else {

        htmlBody += `
        <div class="main-container">
        <div class="location-step3-infos-periode">
            <h3>Nous avons bien reçu votre demande location</h3>

            <div>
                <div>
                    <p>Bonjour, merci pour votre demande de matériel. Nous allons l'étudier très rapidement pour voir si nous pouvons la confirmer. Si nos stocks sont suffisants et les conditions météo favorables, vous recevrez une confirmation par mail avec un lien vers la page de paiement en ligne. Vous pourrez ainsi finaliser votre location et n'aurez plus rien à régler, une fois sur place, plage du Lion.<br>Cordialement.<br>ref. location :${locInfos.ref_location} </p>
                </div>

            </div>
        </div>
    </div>
`

    }

    htmlBody += `

    <div class="main-container">
        <div class="location-step3-infos-periode">
            <h3>Durée de location</h3>

            <div class="location-step3-infos-periode-content">
                <table>
                    <tr>
                        <td>
                        <p>${dayjs(location.d1).format("dddd DD/MM")} à ${convertHoraire(location.h1, "horaire")}</p>
                        </td>
                        <td>
                        <p>Au ${dayjs(location.d2).format("dddd DD/MM")} à ${convertHoraire(location.h2, "horaire")}</p>
                        </td>
                        <td>
                        <h4>soit ${getDureeInfos(calculDuree(location))}</h4>
                        </td>
                    </tr>
                </table>

            </div>
        </div>
    </div>
    <div class="main-container">
        <div class="location-step3-panier-title">
            <h3>${destinataire === "wally" ? "Panier du client" : "Votre panier"}</h3>

        </div>
        <div class="location-panier-list">
            <table>
                <tr>
                    <th class="col1"></th>
                    <th class="col2">Article</th>
                    <th>Taille</th>
                    <th>Quantité</th>
                    <th>P.U.</th>
                    <th>Prix HT</th>
                    <th>Prix TTC</th>
                </tr>`;


    panier.forEach(item => {
        htmlBody += ` 
                    <tr>
                    <td class="col1"><img
                            src="https://www.wallyglisse.com/nestor/images/photos/${getArticle(item).image_url.split(',')[0]}"
                            alt="${getArticle(item).description}"></td>
                    <td class="col2">
                    <h3>${getArticle(item).Type.nom_type} ${getArticle(item).Categorie.nom_categorie}</h3>
                    <p><strong>${getArticle(item).description}</strong> / ${getArticle(item).infos}</p>
                    </td>
                    <td>
                        <p>${getTailleInfo(item.taille_id)}</p>
                    </td>
                    <td>
                        <p>${item.qte}</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location))}€</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location) * item.qte / 1.2)}€</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location) * item.qte)}€</p>
                    </td>
                </tr>
                
                    `
    })

    if (totalPanier.combos > 0) {

        htmlBody += `<tr class="ligne-discount">
        <td colspan="2" class="col2">
        <h3>KITS PLANCHE+COMBI</h3>
        <p>Réductions appliquées pour les ensembles planche &amp; combinaison</p>
        </td>
        <td>
        </td>
        <td>
        <p>${totalPanier.combos}</p>
        </td>
        <td>
        <p>- ${tarifDecimalConverter(totalPanier.difference)}€</p>
        </td>
        <td>
        </td>
        <td>
        <p>- ${tarifDecimalConverter(totalPanier.difference * totalPanier.combos)}€</p>
        </td>
        </tr>`
    }

    htmlBody += `
                <tr class="ligne-total">
                    <td colspan="2" class="col2">
                        <h3>TARIF TOTAL DU PANIER</h3>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter((totalPanier.total - totalPanier.difference * totalPanier.combos) / 1.2)}€</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(totalPanier.total - totalPanier.difference * totalPanier.combos)}€</p>
                    </td>
                </tr>
            </table>

        </div>
    </div>`;

    if (location.commentaire.length > 0) { //mail wally
        htmlBody += `
    <div class="main-container">
        <div class="location-step3-infos-client">
            <h3>${destinataire === "wally" ? "Commentaire client" : "Votre commentaire"}</h3>
            <div>
            <p>${location.commentaire}</p>
            </div>
        </div>
    </div>`;
    }

    if (destinataire === "wally") { //mail wally
        htmlBody += `
    <div class="main-container">
        <div class="location-step3-infos-client">
            <h3>Coordonnées client</h3>

            <div class="location-step3-infos-client-content">
                <table>
                    <tr>
                        <td>
                        <h4>${client.prenom + " " + client.nom}</h4>
                        <p>${"Téléphone : " + client.tel}</p>
                        <p>${"Email : " + client.email}</p>
                        </td>
                        <td>
                        <p>${"Téléphone 2 : " + client.tel2}</p>
                        ${client.adresse_vacances != "" ?
                `<p>Adresse de vacances : ${client.adresse_vacances}</p>`
                :
                null
            }
                        </td>

                    </tr>
                </table>

            </div>
        </div>
    </div>`

    } else { // pour le mail  client
        htmlBody += `
    <div class="main-container">
        <div class="location-step3-infos-client">
            <h3>Nous Contacter</h3>
            <div class="location-step3-infos-client-content">
                <table>
                    <tr>
                        <td>
                        <h4>Wally Glisse</h4>
                        <p>Téléphone : +33(0) 6 19 07 05 53 </p>
                        <p>Email : wallyglisse@gmail.com</p>
                        </td>
                        <td>
                        <h4>Point de retrait du matériel : </h4>
                        <p>Ecole de surf Wally Glisse</p>
                        <p>Plage du Lion, parking super sud</p>
                        <p>33680, lacanau Océan</p>
                        </td>

                    </tr>
                </table>

            </div>
        </div>
    </div>`

    }

    htmlBody += `

</body>

</html>

`;

    return htmlBody;

}